export default __webpack_public_path__ + "static/media/voicegot-screenshot-04.10625529.png";